import { TrackFieldfocusDirective } from '@analytics/events';
import { Component, input, type OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  CrntFormControl,
  CrntFormControlHelpText,
  CrntFormControlLabel,
  CrntFormControlLabelIndicator,
  CrntTextInput,
} from '@essent/current-web-angular';
import { AutomationIdDirective } from '@innogy/utils-automation-id';

import { RfaFormControl, RfaValidators } from '../../../level1';
import { focusChangeOptionsToConfig } from '../../helpers/tracker-options-to-config';
import type { RfaFocusChangeTrackerOptions } from '../../models/rfa-tracker-options.interface';
import type { RfaComponents } from '../RfaComponents';
import { RfaErrorsComponent } from '../utils/rfa-errors/rfa-errors.component';
import { RfaPrefixSuffixComponent } from '../utils/rfa-prefix-suffix/rfa-prefix-suffix.component';

@Component({
  selector: 'rfa-number-input',
  standalone: true,
  templateUrl: './rfa-number-input.component.html',
  imports: [
    ReactiveFormsModule,
    RfaErrorsComponent,
    RfaPrefixSuffixComponent,
    CrntFormControl,
    CrntFormControlLabel,
    CrntFormControlHelpText,
    CrntTextInput,
    CrntFormControlLabelIndicator,
    AutomationIdDirective,
    TrackFieldfocusDirective,
  ],
  styleUrls: ['./rfa-number-input.component.scss'],
})
export class RfaNumberInputComponent implements OnInit {
  readonly control =
    input.required<
      RfaFormControl<
        (typeof RfaComponents.NumberInput)['valueType'],
        typeof RfaComponents.NumberInput
      >
    >();

  autocompleteId!: string;

  ngOnInit(): void {
    this.autocompleteId =
      this.control().options.autocompleteId ??
      this.control().generateRandomAutocompleteId();
  }

  get showOptional(): boolean {
    return !this.control().hasValidator(RfaValidators.required);
  }

  focusChangeTrackConfig() {
    const focusChangeOptions: RfaFocusChangeTrackerOptions = this.control()
      .options.analytics?.focusChangeTracker ?? {
      fieldName: this.control().options.label,
    };

    return focusChangeOptionsToConfig(focusChangeOptions, {
      fieldName: this.control().options.label,
      hashValue: false,
    });
  }
}
